import { render } from "./OcrDataTable.vue?vue&type=template&id=298392a4"
import script from "./OcrDataTable.vue?vue&type=script&lang=js"
export * from "./OcrDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__